import { useState } from "react";
import { sendTestEmail } from "@/api/admin.api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail } from "lucide-react";

export function EmailTestPage() {
  const [to, setTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<{ success: boolean; message: string } | null>(null);

  const handleSend = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    try {
      const res = await sendTestEmail(to);
      setResult(res);
    } catch (err) {
      setResult({ success: false, message: (err as Error).message || "Gonderilemedi" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md">
      <h1 className="mb-6 text-2xl font-bold">Email Test</h1>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Mail className="size-5" />
            Test Emaili Gonder
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSend} className="space-y-4">
            <Input
              type="email"
              placeholder="alici@example.com"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              required
            />
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Gonderiliyor..." : "Test Emaili Gonder"}
            </Button>
          </form>
          {result && (
            <p className={`mt-4 text-sm ${result.success ? "text-green-600" : "text-red-600"}`}>
              {result.message}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
